import { useEffect } from 'react';

// Aktiviert die Scroll-Reveal-Animation (.reveal → .visible) für alle Elemente
// mit der Klasse "reveal" auf der aktuell gemounteten Seite. Muss von jeder
// Seite aufgerufen werden, die .reveal-Klassen nutzt (z. B. HomePage, CoachingLandingPage).
export function useScrollReveal() {
  useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') return undefined;
    const els = document.querySelectorAll('.reveal');
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('visible'); } }),
      { threshold: 0.12 },
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}
